import { render } from "./ConcedeGameModal.vue?vue&type=template&id=63b43ae4&scoped=true&ts=true"
import script from "./ConcedeGameModal.vue?vue&type=script&lang=ts"
export * from "./ConcedeGameModal.vue?vue&type=script&lang=ts"

import "./ConcedeGameModal.vue?vue&type=style&index=0&id=63b43ae4&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b43ae4"]])

export default __exports__